import {AlertIcon} from '@primer/octicons-react'
import {clsx} from 'clsx'
import styles from '../SidebarSection.module.css'

export function ReviewersError() {
  return (
    <span className={clsx(styles.emptyState, 'd-flex flex-items-center gap-2')}>
      <AlertIcon className="color-fg-danger" />
      Unable to load reviewers
    </span>
  )
}
